import { EsignEditApp } from "eSign/EsignEditApp";
import EsignLandingApp from "eSignLanding/App";
import ESignForMeListPanel from "eSignForMe/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const esignRoute: RouteObject = {
  children: [{
    path: "contract/:key/esign",
    loader: () => viewModel,
    Component: EsignEditApp,
  }, {
    path: "quote/:key/esign",
    loader: () => viewModel,
    Component: EsignEditApp,
  }, {
    path: "purchaseagreement/:key/esign",
    loader: () => viewModel,
    Component: EsignEditApp,
  }, {
    path: "esign/invitation/:secret",
    loader: () => viewModel,
    Component: EsignLandingApp,
  }, {
    path: "esign/forme",
    loader: () => viewModel,
    Component: ESignForMeListPanel,
  }]
};